interface OnboardingInstructionsProps {
  onImportFile: () => void;
}

export function OnboardingInstructions({
  onImportFile,
}: OnboardingInstructionsProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4">
      <div className="max-w-md text-center">
        <div className="text-5xl mb-6" aria-hidden="true">
          📥
        </div>

        <h1 className="text-3xl font-bold text-brand-primary mb-6">
          Obtén tu estado de cuenta
        </h1>

        <ol className="text-left text-near-black space-y-3 mb-8">
          <li className="flex items-start gap-3">
            <span className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-primary text-white text-sm flex items-center justify-center">
              1
            </span>
            <span>Ingresa a tu banca en línea (app o web)</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-primary text-white text-sm flex items-center justify-center">
              2
            </span>
            <span>Ve a tu tarjeta de crédito</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-primary text-white text-sm flex items-center justify-center">
              3
            </span>
            <span>Selecciona "Movimientos"</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-primary text-white text-sm flex items-center justify-center">
              4
            </span>
            <span>Elige rango de fechas</span>
          </li>
          <li className="flex items-start gap-3">
            <span className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-primary text-white text-sm flex items-center justify-center">
              5
            </span>
            <span>Descarga como Excel (.xlsx)</span>
          </li>
        </ol>

        <button
          onClick={onImportFile}
          className="w-full px-6 py-3 bg-brand-primary text-white rounded-lg hover:bg-brand-secondary transition-colors font-medium flex items-center justify-center gap-2"
        >
          <span aria-hidden="true">📁</span>
          Importar archivo
        </button>
      </div>
    </div>
  );
}
